<template>
    <v-layout mt-2 row :class="{'bold-text': open}">
      <v-flex xs2 class="body-2" >
        {{breakdownInfo.id}}
      </v-flex>
      <v-flex xs2 class="hidden-xs-only body-2 ml-1">
        {{breakdownInfo.requestFromDate | date}}
      </v-flex>
      <v-flex xs2 class="hidden-xs-only body-2 ml-3" >
        {{breakdownInfo.requestToDate | date}}
      </v-flex>
      <v-flex xs2 class="body-2 ml-2">
        {{breakdownInfo.recordsProcessed}}
      </v-flex>
      <v-flex xs2 class="body-2 ml-3">
        {{breakdownInfo.recordsErrored}}
      </v-flex>
    </v-layout>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'
  import Colors from '../../mixins/Colors'
  import {STORE_FEED_BREAKDOWN_AUDIT_ID, GET_AUDIT_BREAKDOWN_INFO} from '../../store/action-types'
  export default {
    name: 'feed-request-breakdown-info-header',
    mixins: [Colors, DateFormat],
    props: ['breakdownInfo', 'open'],
    data () {
      return {
      }
    },
    mounted () {
      this.changeColors()
    },
    methods: {
      changeColors () {
        const bgColor = this.lightenColor(this.$vuetify.theme.primary, 2)
        const textColor = this.getTextColor(bgColor)
        this.$el.parentElement.parentElement.style.backgroundColor = this.open ? bgColor : ''
        this.$el.parentElement.parentElement.style.color = this.open ? textColor : ''
        this.iconStyle = this.open ? {color: textColor} : ''
      }
    },
    watch: {
      open (value) {
        this.changeColors()
        if (value) {
          this.$store.dispatch(STORE_FEED_BREAKDOWN_AUDIT_ID, this.breakdownInfo.id)
          this.$store.dispatch(GET_AUDIT_BREAKDOWN_INFO)
        }
      }
    }
  }
</script>

<style scoped>

  .bold-text {
    font-weight: 900;
  }

  .align-self-center {
    align-self: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/monitor/FeedRequestBreakdownInfoHeader.vue